<div class="auth-card__dropdown auth-card__phone-field">
  <div class="auth-card__input-wrapper auth-card__phone-wrapper">
    <span aria-hidden="true">📞</span>
    <span class="auth-card__phone-divider" aria-hidden="true"></span>
    <button
      type="button"
      class="auth-card__phone-country-toggle"
      aria-haspopup="listbox"
      [attr.aria-expanded]="countryMenuOpen()"
      aria-label="Select country code"
      (click)="toggleCountryMenu()"
    >
      <span aria-hidden="true">{{ selectedCountryFlag() }}</span>
      <span class="auth-card__dropdown-caret" aria-hidden="true">▾</span>
    </button>
    <span class="auth-card__phone-code">{{ selectedCountryDialCode() }}</span>
    <input
      type="tel"
      name="phoneNumber"
      [placeholder]="placeholder()"
      [ngModel]="phoneNumber()"
      (ngModelChange)="phoneNumber.set($event)"
      [ngModelOptions]="{ standalone: true }"
      required
    />
  </div>
  @if (countryMenuOpen()) {
    <div class="auth-card__dropdown-menu">
      <div class="auth-card__dropdown-search">
        <span aria-hidden="true">🔍</span>
        <input
          type="text"
          placeholder="Search country"
          [ngModel]="countrySearch()"
          (ngModelChange)="countrySearch.set($event)"
          [ngModelOptions]="{ standalone: true }"
          (click)="$event.stopPropagation()"
          autofocus
        />
      </div>
      <ul class="auth-card__dropdown-list" role="listbox">
        @for (item of filteredCountries(); track item.name) {
          <li
            role="option"
            [attr.aria-selected]="item.name === country()"
            [class.auth-card__dropdown-item--active]="item.name === country()"
            class="auth-card__dropdown-item"
            (click)="selectCountry(item.name)"
          >
            <span class="auth-card__dropdown-item-label">
              <span aria-hidden="true">{{ countryFlag(item.code) }}</span> {{ item.name }}
            </span>
            <span class="auth-card__dropdown-item-code">{{ item.dialCode }}</span>
          </li>
        } @empty {
          <li class="auth-card__dropdown-empty">No countries found</li>
        }
      </ul>
    </div>
  }
</div>
